import { wordPressPublishCommand } from './wordpress_publish';

export const wordPressCommands = [
  wordPressPublishCommand,
];

